import React from 'react';
import { useSelector } from 'react-redux';
import { seoStateSelector } from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';
import SeoSrpCarousel from '../srp-card/seo-srp-carousel';
import ListForLinks from '@stencil/commonstories/src/components/Seo/list-for-links/list-for-links';
import AirportContact from '@stencil/commonstories/src/components/Seo/airport-contact/airport-contact';
import HotelsAttractionsInformation from '@stencil/commonstories/src/components/Seo/hotels-attractions-information/hotels-attractions-information';
import getListWithNewTitle from '@stencil/flights-utils/src/get-list-with-new-title';
import FlightHotel from '@stencil/commonstories/src/components/Seo/flights-hotels-attraction/flight-hotel';
import { FLIGHTS_TEXT, TO } from '@stencil/flights-constants/src/text';

const SeoFlightsToFlightsFromLeft = props => {
  const seoState = useSelector(seoStateSelector);
  const {
    source,
    destination,
    cityContact,
    hotels_near_airport,
    offers,
    city_sectors,
    topIntlRoutes,
    topIntlCities,
    cityLinkedData,
    queryType,
    language,
    cityAirport,
    hotelData
  } = seoState;

  const city = queryType.includes('flights-to') ? destination : source;
  const { name, hindi_name, iata: cityIata, city_hotels_link } = city;
  const cityName = language === 'hindi' && hindi_name ? hindi_name : name;
  const renderHotelsSections = () => {
    return hotelData.map((currentItem, index) => {
      if (currentItem && currentItem.links && currentItem.links.length) {
        return (
          <ListForLinks
            key={`${currentItem.title}_${index}`}
            title={currentItem.title}
            links={currentItem.links}
            isDweb={true}
          />
        );
      }
      return null;
    });
  };
  return (
    <>
      <SeoSrpCarousel offers={offers} />
      {city_sectors && city_sectors.length > 0 ? (
        <FlightHotel
          city_sectors={city_sectors}
          headerTitle={`${cityName} (${cityIata}) flights also serves`}
          city={city}
          isDweb={true}
        />
      ) : null}
      {cityLinkedData && cityLinkedData.length > 0 ? (
        <ListForLinks
          title={`Further Flights from ${cityName} (${cityIata})`}
          links={getListWithNewTitle(
            cityLinkedData,
            `${cityName} ${TO[language]} %s ${FLIGHTS_TEXT[language]}`
          )}
          isDweb={true}
        />
      ) : null}
      {topIntlRoutes ? (
        <ListForLinks
          title="Top International Routes"
          html={topIntlRoutes.api_url}
          links={[]}
          isDweb={true}
        />
      ) : null}
      {topIntlCities ? (
        <ListForLinks
          title="Top International Cities"
          html={topIntlCities.api_url}
          links={[]}
          isDweb={true}
        />
      ) : null}
      {hotelData?.length > 0 && renderHotelsSections()}
      {cityAirport ? (
        <AirportContact
          contactDetailsHTML={cityAirport.contact_details || ''}
          locName={cityName}
          isDweb={true}
        />
      ) : null}
    </>
  );
};

export default SeoFlightsToFlightsFromLeft;
